module.exports = {"230751100":"西林镇","230751101":"金山屯镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230751.json
// module id = 853
// module chunks = 0